import React, { Fragment } from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import { formattedCustomAnswer } from '../../../services/orderCustomFields';

const textColor = '#2A4494';

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: 24,
    flexWrap: 'wrap'
  },
  field: {
    flexDirection: 'column',
    marginRight: 20
  },
  label: {
    paddingBottom: 3,
    fontSize: 12,
    color: textColor,
    fontStyle: 'bold'
  },
  desc: {
    fontSize: 11
  }
});

const InvoiceCustomFields = ({customAnswers}) => {
  return (
    <Fragment>
      <View style={styles.container}>
        {customAnswers.map(customAnswer => (
          <View key={`custom-field-${customAnswer.id}`} style={styles.field}>
            <Text style={styles.label}>{customAnswer.custom_field.label}</Text>
            <Text style={styles.desc}>{formattedCustomAnswer(customAnswer)}</Text>
          </View>
        ))}
      </View>
    </Fragment>
  );
}

export default InvoiceCustomFields;